import { Hidden } from '@backyard-ui/core';

import { Authenticated } from './Authenticated';
import { Unauthenticated } from './Unauthenticated';

import { useHeaderStore } from '../../../Header.store';

function UserMenu() {
  const { isAuthenticated, isAssistedSale } = useHeaderStore((state) => ({
    isAuthenticated: state.user?.isAuthenticated,
    isAssistedSale: state.user?.isAssistedSale,
  }));

  return (
    <Hidden above="lg">
      {isAuthenticated || isAssistedSale ? (
        <Authenticated />
      ) : (
        <Unauthenticated />
      )}
    </Hidden>
  );
}

export default UserMenu;
